import React, { useState } from "react";
import { updateFreelancerProfile } from "../../../../../services/freelancerService";

const YearsOfExperience = ({ initialYears }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [years, setYears] = useState(initialYears || 0);
    const [tempYears, setTempYears] = useState(years);
    const [loading, setLoading] = useState(false);

    const handleSave = async () => {
        try {
            setLoading(true);
            await updateFreelancerProfile({ years_of_experience: tempYears });
            setYears(tempYears);
            setIsEditing(false);
        } catch (err) {
            console.error(err);
            alert("Failed to update experience.");
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setTempYears(years);
        setIsEditing(false);
    };

    return (
        <div className="experience-block">
            <h3 className="experience-title">Years of Experience</h3>
            <div className="experience-value-row">
                <p className="experience-value">{years}+ years</p>
            </div>
        </div>
    );
};

export default YearsOfExperience;
